import userRouter from '@/routers/modules/user';
import articleRouter from '@/routers/modules/article';
import pageRouter from '@/routers/modules/page';
import baiduVisitorRouter from '@/routers/modules/baidu-visitor';
import spiderRouter from '@/routers/modules/spider';
import accessRouter from '@/routers/modules/access';
import statisticsRouter from '@/routers/modules/statistics';

export const routes = [
  {
    path: '/main',
    name: 'main',
    component: () => import('@/components/main/index'),
    children: [
      articleRouter,
      pageRouter,
      baiduVisitorRouter,
      spiderRouter,
      accessRouter,
      statisticsRouter
      // userRouter
    ],
    meta: { requiresAuth: true }
  },
  { path: '/login',
    name: 'login',
    component: () => import('@/components/pages/login/login'),
    meta: { requiresAuth: false }
  },
  { path: '/register',
    name: 'register',
    component: () => import('@/components/pages/login/register'),
    meta: { requiresAuth: false }
  },
  { path: '',
    name: 'home',
    component: () => import('@/components/main/index'),
    meta: { requiresAuth: true }
  },
  { path: '*',
    name: 'error',
    component: () => import('@/components/pages/error/index'),
    meta: { requiresAuth: false }
  }
];



// WEBPACK FOOTER //
// ./src/routers/index.js